export default __webpack_public_path__ + "static/media/automatskavrata3.5ac78f23.png";